import { Col, Row } from 'react-bootstrap';
import IncomeInformationInputs from '../../../common/IncomeInformationInputs';
import CalculatedIncomeResults from '../../../common/CalculatedIncomeResults';
import ReferralSourceField from '../../../fields/ReferralSourceField';
import CalculatedBenefitResults from '../../../common/CalculatedBenefitResults';
import CaresBenefitDiff from '../CaresBenefitDiff';

const CaresDiscountAndGrantSection = ({
  form,
  currentEnergyDiscount,
  setFormField,
  hasExistingCaresData,
  isSubmitting,
}) => {

  return (
    <>
      <hr/>
      {/* Income Information */}
      <Row>
        <Col>
          <h4>Income Information</h4>
          <IncomeInformationInputs
            householdSize={form?.householdSize}
            onHouseholdSizeChange={value => setFormField('householdSize', value)}
            income={form?.income}
            onIncomeChange={value => setFormField('income', value)}
            arrearsLiabilityAmount={form?.arrearsLiabilityAmount}
            onArrearsLiabilityAmountChange={value => setFormField('arrearsLiabilityAmount', value)}
            isSubmitting={isSubmitting}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col>
          <CalculatedIncomeResults
            incomeMeasurementType={form?.incomeMeasurementType}
            incomeMeasurementPercentage={form?.incomeMeasurementPercentage}
            arrearage={form?.arrearage}
            isSubmitting={isSubmitting}
          />
        </Col>
      </Row>

      <hr/>
      {/* Benefit Amounts */}
      <CalculatedBenefitResults
        energyDiscount={form?.energyDiscount}
        pledgeAmount={form?.pledgeAmount}
      />

      <CaresBenefitDiff
        fundType={form?.fundType}
        newEnergyDiscount={form?.energyDiscount}
        currentEnergyDiscount={currentEnergyDiscount}
      />

      {!hasExistingCaresData && (
        <>
          <hr/>
          <ReferralSourceField 
            value={form?.referralSource}
            onChange={value => setFormField('referralSource', value)}
            isSubmitting={isSubmitting}
          />
        </>
      )}
    </>
  );
};

export default CaresDiscountAndGrantSection;